import { stringSchema, objectSchema, booleanSchema, enumSchema } from '@/schemas'
import { AllergySeverityEnum, AllergyTypeEnum } from '@/types'

export const medicationSchema = objectSchema({
  id: stringSchema.optional(),
  note: stringSchema,
})

export const allergySchema = objectSchema({
  id: stringSchema.optional(),
  note: stringSchema.optional(),
  severity: enumSchema(Object.values(AllergySeverityEnum)).optional(),
  type: enumSchema(Object.values(AllergyTypeEnum)).optional(),
  adverse_drug_reaction: booleanSchema.optional(),
  description: stringSchema.optional(),
  start_date: stringSchema.optional(),
  end_date: stringSchema.optional(),
})
